import { SERVER_URL } from "./config";

const itemTableHeader = [
  {
    label: "#",
    className: "text-center table-header",
  },
  {
    label: "Item Name",
    className: "text-center table-header",
  },
  {
    label: "Unit",
    className: "text-center table-header",
  },
  {
    label: "Vehicle Type",
    className: "text-center table-header",
  },
  {
    label: " Vehicle Size",
    className: "text-center table-header",
  },
  {
    label: " Box Size",
    className: "text-center table-header",
  },
  {
    label: "Packaging Type",
    className: "text-center table-header",
  },
  {
    label: "Total kms",
    className: "text-center table-header",
  },
  {
    label: "L",
    className: "text-center table-header",
  },
  {
    label: "B",
    className: "text-center table-header",
  },
  {
    label: "H",
    className: "text-center table-header",
  },
  {
    label: "CFT",
    className: "text-center table-header",
  },
  {
    label: "Liter",
    className: "text-center table-header",
  },
  {
    label: "Inch_CM",
    className: "text-center table-header",
  },
  {
    label: "Pkgs",
    className: "text-center table-header",
  },
  {
    label: "Weight",
    className: "text-center table-header",
  },
  {
    label: "Rate",
    className: "text-center table-header",
  },
  {
    label: "Amount",
    className: "text-center table-header",
  },
  {
    label: "New",
    className: "text-center table-header",
  },
];

const tableItemsDisabilityChecker = (data) => {
    const pageState = data.pageState;
    const pageMode = data.pageMode;
    const idx = data.idx;
    let ans = null;
    if (parseInt(process.env.REACT_APP_BILTY_DISABLE_DYNAMIC_TABLE_IN_TBB_MODIFY)){
      ans = (pageMode == "edit" && pageState.pay_type == "4" && !("rate_info" in pageState.item_in[idx] && pageState.item_in[idx].rate_info.length > 0));
    } else {
      ans = false
    }
      
    return ans;
}

let itemTableItems = [
  {
    type: "text",
    name: "item_name",
    label: "Item Name",
    className: "form-control-large-col",
    apiConfigKey: "getItemSuggestions",
    url: SERVER_URL + "/item/",
    suggestionKeyword: "name",
    suggestionKeywordForFetchApiArgs: "name",
    suggestionChooseQueryKeyword: "item_id",
    apiCallRequiredOnGetValue: true,
    suggestionSchema: {
      name: "item_name",
      item_id: "item_id", 
      rate_info: "rate_info",
    },
    newRowFocus: true,
    keyboardNavigationMap:{
      "Enter":{
        nextField: "unit"
      }
    },
    isTable: true,
    parentName: "item_in",
    toValidate: true,
    idClearanceNeeded: "item_id",
    inputDataNeededInSuggestions: true,
    inputDataFilter: {
      "station_from": "same",
      "station_to": "same",
      "consignor_id": "same",
      "consignee_id": "consignee_id",
      "consignee": "consignee",
      "item_id": "same"
    },
    apiCallRequiredOnGetValue: true,
    
  },
  {
    type: "dropdown",
    name: "unit",
    label: "Unit",
    className: "form-control-small-col",
    dropdown_items: [
      { value: "W", label: "W" },
      { value: "C", label: "C" },
      // { value: "T", label: "T" },
      { value: "F", label: "F" },
      // { value: "V", label: "V" },
    ],
    keyboardNavigationMap:{
      "Enter":{
        nextField: "packing_type"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
},
  {
    label: "Vehicle Type",
    className: "form-control-small-col",
    labelClassName: "form-label",
    inputClassName: "form-control-medium-col",
    name: "vehicle_type",
    type: "dropdown",
    dropdown_items: [
      { value: "1", label: "19FT" },
      { value: "13", label: "1MT" },
      { value: "14", label: "2.5MT" },
      { value: "2", label: "3.5MT" },
      { value: "3", label: "5MT" },
      { value: "4", label: "7MT" },
      { value: "5", label: "9MT" },
      { value: "6", label: "BOLLORE/DOST" },
      { value: "7", label: "CANTER" },
      { value: "8", label: "CHAMPION" },
      { value: "9", label: "PICK-UP" },
      { value: "10", label: "TATA ACE" },
      { value: "11", label: "TATA 1109" },
      { value: "12", label: "Tata 407" }
    ],
    placeHolder: "",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "vehicle_size"
      }
    },
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    label: "Vehicle Size",
    className: "form-control-small-col",
    labelClassName: "form-label",
    inputClassName: "form-control-medium-col",
    name: "vehicle_size",
    type: "dropdown",
    dropdown_items: [
      { value: "800 KG", label: "800 KG" },
      { value: "1200 KG", label: "1200 KG" },
      { value: "1700 KG", label: "1700 KG" },
      { value: "2700 KG", label: "2700 KG" },
      { value: "1 TON", label: "1 TON" },
      { value: "2.5 TON", label: "2.5 TON" },
      { value: "3.5 TON", label: "3.5 TON" },
      { value: "5 TON", label: "5 TON" },
      { value: "7 TON", label: "7 TON" },
      { value: "8 TON", label: "8 TON" },
      { value: "9 TON ", label: "9 TON " },
      { value: "10 TON", label: "10 TON" },
      { value: "12 TON", label: "12 TON" },
    ],
    placeHolder: "",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "box_capacity"
      }
    },
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    name: "box_capacity",
    label: "Box Size",
    className: "form-control-small-col",
    type: "dropdown",
    dropdown_items: [
      { value: "150", label: "150" },
      { value: "400", label: "400" },
      { value: "550", label: "550" },
      { value: "800", label: "800" },
      { value: "1050", label: "1050" },
      { value: "1200", label: "1200" },
      { value: "1500", label: "1500" },
      { value: "2500", label: "2500" },
      { value: "3500 ", label: "3500 " },
      { value: "5000", label: "5000" },
      { value: "7500", label: "7500" },
    ],
    keyboardNavigationMap:{
      "Enter":{
        nextField: "packing_type"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    label: "Type Of Packaging",
    className: "form-control-small-col",
    labelClassName: "form-label",
    inputClassName: "form-control-medium-col",
    name: "packing_type",
    type: "dropdown",
    dropdown_items: [
      { value: "1", label: "Carton" },
      { value: "2", label: "Cargo" },
      { value: "3", label: "Bag" },
      { value: "4", label: "Bundle" },
      { value: "5", label: "Bucket" },
      { value: "6", label: "Box" },
      { value: "7", label: "Roll" },
      { value: "8", label: "Drum" },
      { value: "9", label: "Loose" },
      { value: "10", label: "Kantan Pack" },
      { value: "11", label: "Plastic Pack" },
      { value: "12", label: "Pipe" },
      { value: "13", label: "Peti" },
      { value: "14", label: "Carboy" },
      { value: "15", label: "Barrel" },
      { value: "16", label: "Tin" },
    ],
    placeHolder: "",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "total_kms"
      }
    },
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    type: "text",
    name: "total_kms",
    label: "Total KMs",
    className: "form-control-small-col",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "l"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    type: "text",
    name: "l",
    label: "L",
    className: "form-control-small-col",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "b"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    type: "text",
    name: "b",
    label: "B",
    className: "form-control-small-col",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "h"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    type: "text",
    name: "h",
    label: "H",
    className: "form-control-small-col",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "inch_cm"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    type: "text",
    name: "cft",
    label: "CFT",
    className: "form-control-small-col",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "inch_cm"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    type: "text",
    name: "liter",
    label: "Liter",
    className: "form-control-small-col",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "pkgs"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    label: "INCH/CM",
    className: "form-control-small-col",
    name: "inch_cm",
    type: "dropdown",
    dropdown_items: [
      { value: "7", label: "INCH" },
      { value: "8", label: "CM" },
    ],
    placeHolder: "",
    keyboardNavigationMap: {
      "Enter":{
        nextField: "pkgs"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    type: "text",
    name: "pkgs",
    label: "Pkgs",
    className: "form-control-small-col",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "weight"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    type: "text",
    name: "weight",
    label: "Weight",
    className: "form-control-small-col",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "rate"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    type: "text",
    name: "rate",
    label: "Rate",
    className: "form-control-small-col",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "new_row"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    type: "text",
    name: "amount",
    label: "Amount",
    className: "form-control-small-col",
    keyboardNavigationMap:{
      "Enter":{
        nextField: "new_row"
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
  {
    type: "text",
    name: "new_row",
    label: "New",
    className: "form-control-small-col",
    keyboardNavigationMap:{
      "Enter":{
        conditionalNav: true,
        nextFieldOnPage: "actual_weight",
        nextField: "item_name",
      }
    },
    suggestionsOff: true,
    // isDisabled: tableItemsDisabilityChecker,
  },
];

const ewbTableHeader = [
  {
    label: "",
    className: "text-center table-header",
  },
  {
    label: "eWay Bill No.",
    className: "text-center table-header",
  },
  {
    label: "New",
    className: "text-center table-header",
  },
];
const ewbTableItems = [
  {
    type: "text",
    name: "eway_bill_no",
    label: "e-Way Bill Number",
    className: "form-control-medium-col",
    newRowFocus: true,
    keyboardNavigationMap:{
      "Enter":{
        nextField: "new_row"
      }
    },
    suggestionsOff: true,
  },
  {
    type: "text",
    name: "new_row",
    label: "New",
    className: "form-control-small-col",
    keyboardNavigationMap:{
      "Enter":{
        conditionalNav: true,
        nextFieldOnPage: "station_from_name",
        nextField: "item_name",
      }
    },
    suggestionsOff: true,
  },
];
export { itemTableHeader, itemTableItems, ewbTableHeader, ewbTableItems };